import { PaperPlane } from "icons/font-awesome/regular"
import { useAuthApi } from "modules/api-client"
import { ResponseError } from "modules/api-client/src/http-client"
import { useNotifications } from "modules/notifications"
import { useTranslations } from "modules/translations"
import { useRouter } from "next/router"
import React, { FormEvent, ReactNode, useState } from "react"
import FormLayout from "ui-kit/forms/form-layout"
import Input from "ui-kit/forms/input"
import SubmitButton from "ui-kit/forms/submit-button"
import Container from "ui-kit/layout/container"

export default function PasswordEmail (): ReactNode {

    const { translate } = useTranslations()
    const { pushNotification } = useNotifications()
    const { push } = useRouter()
    const { passwordEmailRequest } = useAuthApi()

    const [email, setEmail] = useState<string>( "" )
    const [error, setError] = useState<ResponseError>()
    const [isLoading, setIsLoading] = useState<boolean>( false )

    async function submit ( event: FormEvent ): Promise<void> {
        event.preventDefault()
        setIsLoading( true )
        setError( undefined )
        const response = await passwordEmailRequest( { email: email }, { notifyOnError: false } )
        setIsLoading( false )

        if ( response.success && response.data ) {
            pushNotification( {
                type: "success",
                children: translate( "pages.password-reset.success-link" ),
            } )
            push( "/login" )
        }
        if ( !response.success && response.error ) {
            setError( response.error )
        }
    }

    return <>
        <h1 className="font-black text-3xl text-center mb-16">
            {translate( "pages.password-reset.forgot-password" )}
        </h1>
        <Container size="small">
            <form noValidate onSubmit={submit}>
                <FormLayout>
                    <Input
                        id="email"
                        label={translate( "pages.password-reset.email" )}
                        onChange={value => setEmail( value )}
                        errors={error?.errors?.email}
                        type="email"
                        value={email}
                    />
                    <SubmitButton icon={PaperPlane} loading={isLoading}>{translate( "pages.password-reset.send-link" )}</SubmitButton>
                </FormLayout>
            </form>
        </Container>
    </>
}
